import Image from 'next/image';

import Button from '@/components/common/Button/Button';
import type { FilterValueRecordModelType } from '@/models/api';

interface IFilterButton {
  filter: FilterValueRecordModelType;
  checked?: boolean;
  onChange?: () => void;
  disabled?: boolean;
}

const FilterButton: React.FC<IFilterButton> = ({
  filter,
  checked = false,
  onChange,
  disabled,
}) => {
  const icon = checked ? filter?.icon?.url : filter?.iconActive?.url;
  const getButtonClassNames = (
    isChecked: boolean,
    isDisabled: boolean = false,
  ) => {
    if (isChecked) {
      return 'flex h-12 w-72 justify-start rounded-md';
    }
    return `flex h-12 w-72 justify-start rounded-md ${
      isDisabled ? 'cursor-not-allowed bg-grey' : 'hover:bg-white'
    }`;
  };
  return (
    <div className="flex">
      <Button
        theme={checked ? 'mealPlan' : 'tertiary'}
        className={getButtonClassNames(checked, disabled)}
        onClick={onChange}
        disabled={disabled}
      >
        {icon && <Image src={icon} alt={''} width={14} height={14} />}
        <span className="max-w-20 pl-2 text-left font-interMedium text-xs">
          {filter.name}
        </span>
      </Button>
    </div>
  );
};

export default FilterButton;
